module.exports = __webpack_public_path__ + "img/comments-question.77ba2ffc.svg";